import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface GerminationRoomExtraProps {
  onAddClick(): void
}

const GerminationRoomExtra = ({
  onAddClick,
}: GerminationRoomExtraProps): JSX.Element => (
  <MainContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Cadastrar nova câmara
    </Button>
  </MainContainer>
);

export default GerminationRoomExtra;
